module.exports = __webpack_public_path__ + "img/ClownofPrizesInkBlack.40f8c852.png";